import { Action } from '@auth-util-lib/auth.model'

export const generateHiddenStorageKey = (action?: Action, id?: string) =>
    `BANNER_HIDDEN:${action ?? ''}${id ? (action ? '_' : '') + `${id}` : ''}`
